import {RouteConfig} from "vue-router";
import {LayoutCommon} from "@/shared/layout";
import {RoleDeclare} from "@/enums/roledeclare";

const ladingRoutes: Array<RouteConfig> = [
    {
        path: "create",
        component: () => import("./FormCreate/index.vue"),
        name: "createLading",
        meta: { title: "Tạo đơn" }
    },
    {
        path: "create/:draftId",
        component: () => import("./FormCreate/index.vue"),
        name: "createLadingDraft",
        props: true,
        meta: { title: "Tạo đơn", hidden: true }
    },
    // {
    //     path: "create-image",
    //     component: () => import("./FormImage/index.vue"),
    //     name: "createLadingImage",
    //     meta: { title: "Tạo đơn hình ảnh" }
    // },
    // {
    //     path: "/ladings/create-excel",
    //     component: () => import("./LadingExcel/index.vue"),
    //     name: "ladingExcel",
    //     meta: { title: "Vận đơn excel" }
    // },
    // {
    //     path: "ladings/update-form-lading",
    //     component: () => import("./FormUpdate/index.vue"),
    //     name: "updateFormLading",
    //     meta: { title: "Cập nhập đơn hàng" }
    // },
    {
        path: "draft",
        component: () => import("./ListDraft/index.vue"),
        name: "ladingDraft",
        meta: { title: "Đơn hàng nháp" }
    },
    {
        path: "update-form-lading/:id",
        component: () => import("./FormUpdate/index.vue"),
        name: "updateFormLadingRouting",
        props: true,
        meta: { title: "Cập nhập đơn hàng", hidden: true}
    }
];

export default ladingRoutes;
